import { Config } from 'final-form'
import { defineComponent } from 'vue'

import { ThesaurusTerm, getTranslatedString } from '@skinsoft/types'
import { thesaurusTermSelectors } from '@skinsoft/selectors'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { Field, Form } from '@skinsoft/ui'

export interface Values {
    motive: string;
    title: string;
}

export const CreateMovementForm = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['onSubmit', 'initialValues', 'motives'],
    template: require('./create-movement-form.html'),
    methods: {
        motivesToOptions() {
            return this.motives.map(term => {
                const translatedString = getTranslatedString(
                    thesaurusTermSelectors.preferredTerm(term),
                    this.getAppLocale()
                )

                return {
                    text: this.$te(translatedString) ? this.$t(translatedString) : translatedString,
                    value: term.id,
                };
            });
        },
        async validate(values): Promise<object> {
            // need to be a promise to avoid conflict with $t mixin
            const errors = {} as any;

            if (!values.title) {
                errors.title = this.$t('movement.createModal.form.titleMissing');
            }

            return errors;
        },
    },
})
